/**
 * @generated SignedSource<<82f246e8f5312caaef990e0dbb985577>>
 * @relayHash ca0e9a276ebb1bdbf77f24608fd2a11f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c89f39c033fb27269ee810086f850ec8e3612d01711b808620ba9a4c1a7fa4e1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceOptimizationSettingsPageQuery } from './WorkforceOptimizationSettingsPageQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceOptimizationSettingsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c89f39c033fb27269ee810086f850ec8e3612d01711b808620ba9a4c1a7fa4e1",
    "metadata": {},
    "name": "WorkforceOptimizationSettingsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
